import React,{Component} from 'react';
import {
  Collapse,
  FormGroup,
  Label,
  Input,
  FormText
} from 'reactstrap';

import InfoTooltip from '../InfoTooltip';

import capitalize from 'lodash/capitalize';
import './RadioButtonAccordion.css'

class RadioButtonAccordion extends Component {
  constructor(props){
    super(props);

    this.state ={
      value: null,
      exclude: this.props.exclude
    }
  }

  componentWillMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue, exclude: this.props.exclude});
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.defaultValue !== this.props.defaultValue){
      this.setState({value:nextProps.defaultValue, exclude: nextProps.exclude});
    }
  }

  handleRadioButtonClick(event,section,exclude){
    this.setState({value:section.name, exclude: exclude});
    if(this.props.onChange){
      this.props.onChange(section, exclude);
    }
  }

  render(){
    const { value, exclude } = this.state,
      { sections, name } = this.props;

    return (
      <div>
        {sections.map((section,i) => (
          <div key={i}>
            { section.singleOption ?
              <FormGroup check inline className='RadioButtonAccordion-options'>
                <Label check>
                  <Input type="radio"
                         name={name}
                         value={section.name}
                         checked={value === section.name}
                         onClick={(event) => this.handleRadioButtonClick(event,section)} />
                  &nbsp;&nbsp;{section.display || capitalize(section.name)}
                  {section.tooltip && (
                    <InfoTooltip text={section.tooltip} />
                  )}
                </Label>
              </FormGroup>
            : (
              <div>
              <FormGroup className='RadioButtonAccordion-header'>
                <Label>
                  &nbsp;&nbsp;{section.display || capitalize(section.name)}
                  {section.tooltip && (
                    <InfoTooltip text={section.tooltip} />
                  )}
                </Label>
              </FormGroup>
              <FormGroup check inline className='RadioButtonAccordion-options'>
              <Label check>
              <Input type="radio"
              name={name}
              value={section.name}
              checked={value === section.name && exclude !== true}
              onClick={(event) => this.handleRadioButtonClick(event,section,false)} /> Include
              </Label>
              </FormGroup>
              <FormGroup check inline className='RadioButtonAccordion-options'>
              <Label check>
              <Input type="radio"
              name={name}
              value={section.name}
              checked={value === section.name && exclude === true}
              onClick={(event) => this.handleRadioButtonClick(event,section,true)} /> Exclude
              </Label>
              </FormGroup>
              </div>
              )
            }
            {section.renderSection && (
              <Collapse isOpen={value === section.name}>
                <div style={{marginTop:5,marginLeft:26}}>
                  {section.renderSection(exclude)}
                </div>
              </Collapse>
            )}
          </div>
        ))}
      </div>
    )
  }
}

export default RadioButtonAccordion;



// WEBPACK FOOTER //
// ./src/shared/components/RadioButtonAccordion/index.js